import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from '../../config.service';
import { GeographicArea } from '../../../_models/user/geographicArea';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GeographicAreasService implements OnDestroy {
  private readonly baseUrl = this.environment.commonUtilityApi.baseUrl;
  private readonly getGeographicAreasUrl = this.baseUrl + this.environment.commonUtilityApi.geographicAreas;
  private _geographicAreas = new BehaviorSubject<GeographicArea[]>(null);
  enabledGeographicAreas$ = this._geographicAreas.asObservable();

  private _destroying = new Subject<void>()

  constructor(private http: HttpClient, private environment: ConfigService) { }

  /**
    * @description Returns current("enabled") geographic areas. This is the dataset you will want unless you're viewing historic/deprecated datasets.
   */
  getEnabledGeographicAreas() {
    return this.http.get<GeographicArea[]>(this.getGeographicAreasUrl, {params: {isEnabled:"true"}});
  }
  /**
   * @description Returns the union of both "enabled" and "disabled" geographic areas.
   * @deprecated Only use this in the context of historic incidents. For all generation of new incidents use getEnabledGeographicAreas()
   */
  getAllGeographicAreas() {
    return this.http.get<GeographicArea[]>(this.getGeographicAreasUrl);
  }

  /**
   * @description Returns the "national geographic area". Only use this for informational purposes. Do not reference this geographic area in other locations
   */
  getNationalGeographicAreas() {
    return this.http.get<GeographicArea>(this.baseUrl + "/nationalGeographicArea");
  }

  getEnabledGeographicAreasValue(): GeographicArea[] {
    return this._geographicAreas.value
  }

  getAndBroadcastEnabledGeographicAreas() {
    this.getEnabledGeographicAreas().pipe(takeUntil(this._destroying)).subscribe(gas => {
      this._geographicAreas.next(gas);
    });
  }

  ngOnDestroy(): void {
    this._destroying.next()
    this._destroying.complete()
  }
}
